import React from "react";

function NoMatch() {
  return (
    <div className="mt-5">
      <p>PAGE NOT FOUND</p>
    </div>
  );
}

export default NoMatch;
